export const getWetLeaseApi = (params, query) => {

    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/wet-lease/${queryString ? `?${queryString}` : ""}`;
};

export const getWetLeaseCardDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/wet-lease/config`;
}

export const addWetLeaseApi = (params) => {
    return `lease/${params?.leaseSlug}/wet-lease/`;
};
export const updateWetLeaseApi = (params) => {
    return `lease/${params?.leaseSlug}/wet-lease/${params?.slug}/`;
};

export const updateWetLeaseCardDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/wet-lease/config`;
}

export const deleteWetLeaseApi = (params) => {
    return `lease/${params?.leaseSlug}/wet-lease/`;
};
export const exportWetLeaseApi = (leaseId) => {
    return `lease/${leaseId}/export/wet-lease/`;
};

export const wetLeasefileUploadPostApi = (wetwet_lease_slug) => {
    return `/get-pre-signed-url/wet_lease/${wetwet_lease_slug}`;
};

export const wetLeaseAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/wet_lease/${attachments_slug}`
}
